/* Email offer: exact allowlisted code, one fixed discount per cart. */
(function () {
  'use strict';
  var offer = {"code": "W-SUMMER-057BCB58", "amount": 1410, "endsAt": "2026-09-07T14:59:00Z", "link": "https://wandryshop.myshopify.com/zh-tw/products/wandry?ec_offer=W-SUMMER-057BCB58"};
  var key = 'ec-special-offer-v1';
  var selected = false;
  try {
    selected = new URLSearchParams(location.search).get('ec_offer') === offer.code || sessionStorage.getItem(key) === offer.code;
    if (selected) sessionStorage.setItem(key, offer.code);
  } catch (_) {}
  function current() { return selected && Date.now() < Date.parse(offer.endsAt) ? offer : null; }
  function clear() { selected = false; try { sessionStorage.removeItem(key); } catch (_) {} }
  window.EC_SPECIAL_OFFER = {current:current, clear:clear};
  window.EC_OFFER_AMOUNT = function () { var active=current(); return active ? active.amount : 610; };
  function syncCartNotice() {
    var active=current(); if(!active)return;
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach(function(root){
      var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT),node;
      while((node=walker.nextNode())) {
        if(node.nodeValue.indexOf('訂閱電子報現折NT$610')>=0) node.nodeValue=node.nodeValue.replace('訂閱電子報現折NT$610','今日限定，訂單合計現折NT$'+active.amount.toLocaleString('zh-TW')+'');
      }
    });
  }
  if (typeof document!=='undefined') document.addEventListener('DOMContentLoaded',function(){
    syncCartNotice();
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach(function(root){new MutationObserver(syncCartNotice).observe(root,{childList:true,subtree:true});});
  },{once:true});
})();
